/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserProfile } from './userProfile';
import { CompanyRef } from './companyRef';


export interface User { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    email: string;
    /**
     * can be used as an alternative for email to login
     */
    username: string;
    status: User.StatusEnum;
    firstName?: string;
    lastName?: string;
    salutation?: string;
    companyInfo?: string;
    sso?: boolean;
    expiryDate?: string;
    agency: CompanyRef;
    timezone?: string;
    groups?: Array<object>;
    profile: UserProfile;
    lastLogin?: string;
    firstLoginDate?: string;
    externalFlag?: boolean;
    failedLoginAttempts?: number;
}
export namespace User {
    export type StatusEnum = 'active' | 'inactive';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


